import { render } from "./task_form.vue?vue&type=template&id=6c884f66&scoped=true"
import script from "./task_form.vue?vue&type=script&lang=js"
export * from "./task_form.vue?vue&type=script&lang=js"

import "./task_form.vue?vue&type=style&index=0&id=6c884f66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c884f66"]])

export default __exports__